import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Heading from "../../../../components/Heading";
import { Button } from "../../../../components/Button";
import CommonGrid from "../../../../components/CommonGrid";
import DynamicComponentRenderer from "../../../../components/DynamicComponentRenderer";
// import { loadingTypes } from "../../../../Utils/constant";
import { gridColumns_Borrower_Bank_Accounts } from "../../../../Utils/TableColumnDefs";
// import useBankDetails from "../../../../hooks/useBankDetails";
import { useDispatch, useSelector } from "react-redux";
import useBorrowerDashboardTwo from "../apis/useBorrowerDashboardTwo";
// import { useAbortController } from "../../../../hooks/useAbortController";
import { loadingTypes } from "../../../../Utils/constant";
import axiosInstance from "../../../../axios";
import urls from "../../../../Utils/urls";
// import { useAbortController } from "../../../../hooks/useAbortController";
import { setRefreshBankingDetails } from "../../../../store/reducers/accountSlice";
import { ArrowLeft } from "react-bootstrap-icons";
// import CustomBreadCrumbs from "../../../../components/CustomBreadCrumbs";

const ManageBanking = () => {
  const [bankDetails, setBankDetails] = useState([]);
  const [status, setStatus] = useState(loadingTypes.idle);

  const refreshTable = useSelector(
    (state) => state.account.refreshBankingDetails
  );
  // const accountId = useSelector((state) => state.account.lenderId);
  // const paymentAccounts = useSelector(
  //   (state) => state.dashboard.borrowerAllLoansBankAccounts.data
  // );
  // const optionStatus = useSelector(
  //   (state) => state.dashboard.borrowerAllLoansBankAccounts.status
  // );
  const { activeAccountList: accountIdsData } = useBorrowerDashboardTwo();
  // const { bankDetails, status } = useBankDetails(accountId, refreshTable);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { signal } = useAbortController();

  const accountIds = accountIdsData?.map((data) => data.value);
  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    async function getAllBankDetails() {
      setStatus(loadingTypes.loading);
      try {
        const requestBody = {
          RecID: accountIds.join(","),
        };

        const response = await axiosInstance.post(
          urls.borrower.getBankingDetailsForAll(userId),
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
            timeout: 3000,
          }
        );

        const data =
          response?.data?.accounts?.map((el) => {
            const updatedObj = Object.keys(el).map((item) => ({
              [item.toLowerCase()]: el?.[item],
            }));

            const result = updatedObj.reduce((acc, curr) => {
              return { ...acc, ...curr };
            }, {});
            return result;
          }) || [];

        setBankDetails(data);
      } catch (error) {
        console.error(error);
      } finally {
        setStatus(loadingTypes.fulfilled);
      }
    }

    if (
      (accountIds?.length && status === loadingTypes.idle) ||
      (accountIds?.length && refreshTable)
    ) {
      dispatch(setRefreshBankingDetails(false));
      getAllBankDetails();
    }
  }, [accountIds?.length, status, refreshTable, userId]);

  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Manage Banking" />,
      role: ["Both"],
      className: "col-sm-6 px-4",
    },
    {
      component: (
        <Button
          className="add-account-button"
          onClick={() => navigate("/add-bank-account")}
          text="+ Add Bank Account"
        />
      ),
      role: ["Both"],
      className: "col-sm-6 px-4 text-end",
    },
    {
      component: (
        <CommonGrid
          className={"bg-white col-sm-12 mt-5 manage-banking-table"}
          title={"Bank Accounts"}
          gridColumns={gridColumns_Borrower_Bank_Accounts(setStatus)}
          columnData={bankDetails}
          status={status}
        />
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
              <span
                className="linkClick"
                role="button"
                onClick={() => navigate(-1)}
              >
                <ArrowLeft size={20} /> Back
              </span>{" "}
              / Manage Banking
            </h6>
          </div>
        </article>

        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default ManageBanking;
